// bild_split — the generic split: paper text half (eyebrow, serif title, serif statement,
// sans paragraph, mono footline) and a full-height photograph on the other half; the edge
// and the image side are slots, the framing comes from the image's companions.
import type { BildSplitContent } from '../../../../shared/deckTypes.js';
import { Abs, Dkp, Emph, FramedImg, PageNo, splitXOf } from './chrome.js';

export default function BildSplitPreview({ content, pageNo }: {
  content: BildSplitContent;
  pageNo?: number | null;
}) {
  const c = content;
  const rec = c as Record<string, unknown>;
  const splitX = splitXOf(rec, 640);
  const left = c.image_side === 'left';
  const textX = left ? splitX + 64 : 64;
  const textW = (left ? 1280 - splitX : splitX) - 64 - 36;
  let y = 96;
  const titleBlock = c.title ? y : null;
  if (c.title) y = 180;
  const bodyY = y;
  if (c.body) y += 250;

  return (
    <Dkp>
      {c.image ? (
        <Abs x={left ? 0 : splitX} y={0} w={left ? splitX : 1280 - splitX} h={720} style={{ overflow: 'hidden' }}>
          <FramedImg src={c.image} content={rec} slotKey="image" />
        </Abs>
      ) : null}

      <Abs x={textX} y={64} w={22} h={1.2} style={{ background: '#C8A96E' }} />
      {c.eyebrow ? (
        <Abs x={textX + 33} y={56} w={textW - 33}><span className="dkp-eyebrow">{c.eyebrow}</span></Abs>
      ) : null}
      {titleBlock !== null ? (
        <Abs x={textX} y={titleBlock} w={textW}>
          <div className="dkp-title" style={{ fontSize: 30 }}>
            {c.title}<span style={{ color: '#C8A96E' }}> ●</span>
          </div>
        </Abs>
      ) : null}
      {c.body ? (
        <Abs x={textX} y={bodyY} w={textW}>
          <div className="dkp-serif" style={{ fontSize: 27, lineHeight: 1.4, fontWeight: 500 }}>{c.body}</div>
        </Abs>
      ) : null}
      {c.body2 ? (
        <Abs x={textX} y={y} w={textW}>
          <div style={{ fontSize: 17.3, fontWeight: 500, color: '#121316', lineHeight: 1.55 }}>
            <Emph text={c.body2} />
          </div>
        </Abs>
      ) : null}
      {c.footer_mono ? (
        <Abs x={textX} y={620} w={textW}><span className="dkp-footline">{c.footer_mono}</span></Abs>
      ) : null}

      <span className="dkp-brand" style={left && c.image ? { color: '#F3F1EC' } : undefined}>NAVEN</span>
      <PageNo n={pageNo} light={!left && !!c.image} />
    </Dkp>
  );
}
